module.exports = __webpack_public_path__ + "img/relevantLogo.c0e9d2b0.png";